// import { Link } from 'react-router-dom';
import styled from 'styled-components';


export const AppInputFieldTransparent  = styled.input
.attrs(() => ({
  className: '',
}))`
max-width:98%;
border: none !important;
outline: none important;
:focus{
    border: none !important;
    outline: none important;
}

`;



export const AppInputField  = styled.input
.attrs(() => ({
  className: '',
}))`
border-radius: 5px !important;
padding: 0.1em 0.0em 0.1em 0.3em  !important;
max-width:98%;
border: 1px solid var(--grey, #D9D9D9) !important;
:focus{
    border: 1px solid var(--primary-indigo, #4F46E5) !important;
}

`;


export const AppInputFieldSelect  = styled.select
.attrs(() => ({
  className: '',
}))`
border-radius: 5px !important;
padding: 0.2em 0.0em 0.2em 0.5em  !important;
border: 1px solid var(--grey, #D9D9D9) !important;
height:50px;
:focus{
    border: 1px solid var(--primary-indigo, #4F46E5) !important;
}

`;




export const InputFieldTitleText  = styled.h5
.attrs(() => ({
  className: '',
}))`
color: var(--black, #3F3F46);
font-size: 14px !important;
font-family: Plus Jakarta Sans;
font-style: normal;
font-weight: 600;
line-height: normal;
`;

export const DropDownText  = styled.h5
.attrs(() => ({
  className: '',
}))`
color: var(--black, #3F3F46);
font-size: 14px !important;
font-family: Plus Jakarta Sans;
font-style: normal;
font-weight: 600;
line-height: normal;
`;


export const AppInputFieldBtn  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large white-text w-100',
}))`
border-radius: 5px;
background: var(--primary-indigo, #4F46E5) !important;
width:100% !important;
height:46px !important;
:disabled{
    border: 1px solid #999999;
    background-color: #999999 !important;
    color: #666666;
}
`;

export const AppInputFieldBtnCancel  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large  w-100',
}))`
border-radius: 5px;
background: transparent !important;
width:100% !important;
height:46px !important;
color:var(--primary-indigo, #4F46E5) !important;
:disabled{
    border: 1px solid #999999;
    background-color: #999999 !important;
    color: #666666;
}
`;